import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { APP_REQUEST } from '../helpers/request';
import { useAuth } from '../context/AuthProvider';
import SignUpForm from '../components/account/sign-up-form';
import SignupDisabled from '../components/SignupDisabled';
import BackButton from '../components/BackButton';
import Logo from '../components/Logo';
import { FEATURES } from '../constants';
import styles from '../components/loginStyles';

const SignUp = () => {
  const { loading } = useAuth();

  if (loading) {
    return <CircularProgress />;
  }

  if (!FEATURES.ENABLE_SIGNUP) {
    return (
      <div id="sign-up-page" className="auth-form form-container">
        <Box sx={styles.login.back}>
          <BackButton />
        </Box>
        <SignupDisabled />
      </div>
    );
  }

  return (
    <div id="sign-up-page" className="auth-form form-container">
      <Box sx={styles.login.back}>
        <BackButton />
      </Box>

      {/* Logo Section */}
      <Grid container sx={{ maxWidth: '1200px', margin: '0 auto', mb: 0 }}>
        <Grid item xs={12} sx={{ textAlign: 'center', mt: 2 }}>
          <Logo />
        </Grid>
      </Grid>

      <SignUpForm
        onSignInClick={() => {
          APP_REQUEST.redirect('sign-in');
        }}
      />
    </div>
  );
};

export default SignUp;
